import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios'

export const usePurchase = (token, paramId) => {
    const [isLoadingPurchase, setIsLoadingPurchase] = useState(false)
    const [purchase, setPurchase] = useState(null)

    const getPurchase = async () => {
        setIsLoadingPurchase(true)

        try {
            const res = await axios.get(`/purchase/${paramId}`, {
                headers: { Authorization: token }
            })

            setPurchase(res.data)
            setIsLoadingPurchase(false)
        } catch (err) {
            console.log('err', err)
            setIsLoadingPurchase(false)
        }
    }

    useEffect(() => {
        getPurchase()
    }, [token, paramId])

    return { isLoadingPurchase, purchase, getPurchase }
}
